import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-sovereign-navy text-white" data-id="element-95">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-sovereign-navy-light/40 via-sovereign-navy to-sovereign-navy opacity-80" data-id="element-96" />

      {/* Decorative Gold Line */}
      <motion.div initial={{
      height: 0
    }} animate={{
      height: '40%'
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute left-8 top-0 w-[1px] bg-gradient-to-b from-sovereign-gold to-transparent opacity-50 hidden md:block" data-id="element-97" />

      <div className="relative z-10 container mx-auto px-6 py-32 md:py-48 max-w-7xl" data-id="element-98">
        <div className="max-w-4xl" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-100">
            <span className="inline-block py-1 px-3 border border-sovereign-gold/30 rounded-full text-sovereign-gold text-xs tracking-[0.2em] uppercase mb-8 backdrop-blur-sm" data-id="element-101">
              The Pinnacle of Compliance
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium leading-tight mb-8 text-white" data-id="element-102">
            Sovereign <span className="text-sovereign-gold italic" data-id="element-103">eTims</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl font-light leading-relaxed" data-id="element-104">
            Experience the seamless integration of KRA compliance and
            WooCommerce. Designed for the discerning merchant who demands
            elegance in every operation.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: 'easeOut'
        }} className="flex flex-col sm:flex-row gap-6" data-id="element-105">
            <Button size="lg" className="group" onClick={() => scrollToSection('pricing')} data-id="element-106">
              Begin Your Journey
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-107" />
            </Button>
            <Button variant="outline" size="lg" onClick={() => scrollToSection('features')} data-id="element-108">
              Explore Features
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer" onClick={() => scrollToSection('features')} data-id="element-109">
        <span className="text-[10px] uppercase tracking-widest text-sovereign-gold/60" data-id="element-110">
          Scroll
        </span>
        <motion.div className="w-[1px] h-12 bg-gradient-to-b from-sovereign-gold/60 to-transparent" animate={{
        height: [48, 24, 48]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-111" />
      </motion.div>
    </section>;
}